import { render, staticRenderFns } from "./bottom.vue?vue&type=template&id=39f40bc5&scoped=true"
import script from "./bottom.vue?vue&type=script&lang=js"
export * from "./bottom.vue?vue&type=script&lang=js"
import style0 from "./bottom.vue?vue&type=style&index=0&id=39f40bc5&prod&scoped=true&lang=less"
import style1 from "./bottom.vue?vue&type=style&index=1&id=39f40bc5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f40bc5",
  null
  
)

export default component.exports